import React, { useCallback, useReducer, useState } from "react"
import { obterExtratoDetalhado } from "../../../services/extratoPixFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ExtratoPixFornecedorInicial } from "../models/extratoPixFornecedorModel"
import { ExtratoPixFornecedorActionsTypes } from "./extratoPixFornecedorActions"
import { ExtratoPixFornecedorContext } from "./ExtratoPixFornecedorContext"
import { extratoPixFornecedorReducer } from "./extratoPixFornecedorReducer"

export function ExtratoPixFornecedorContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(extratoPixFornecedorReducer, ExtratoPixFornecedorInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregarExtrato = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterExtratoDetalhado(
                autorizacao,
                dados.dataInicio,
                dados.dataFim
            )
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar extrato")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: ExtratoPixFornecedorActionsTypes.CARREGAR,
                    payload: {
                        grupos: response.grupos,
                        resumo: response.resumo,
                        saldo: response.saldo,
                    },
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar extrato")
        } finally {
            setLoading(false)
        }
    }, [dados.dataInicio, dados.dataFim, setLoading])

    return (
        <ExtratoPixFornecedorContext.Provider
            value={{ dados, dispatch, erroCarregamento, carregarExtrato }}
        >
            <Loading />
            {children}
        </ExtratoPixFornecedorContext.Provider>
    )
}
